// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-config-shell {
  width: min(100%, 72rem);
  margin: 0 auto;
  padding: 0.75rem;
}

.menu-config-hero,
.menu-config-controls,
.menu-config-stats,
.menu-config-notice,
.menu-config-groups,
.menu-config-actions {
  border: 1px solid var(--ion-color-step-150);
  background: var(--ion-card-background, var(--ion-background-color));
}

.menu-config-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.1rem 1.25rem;
  border-radius: 1rem;
  box-shadow: 0 0.35rem 1rem rgba(15, 23, 42, 0.08);
}

.menu-config-intro h2 {
  margin: 0.15rem 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.7rem;
}
.menu-config-intro > p:last-child {
  max-width: 46rem;
  margin: 0;
  color: var(--ion-color-medium);
  font-size: 0.9rem;
  line-height: 1.35rem;
}

.menu-config-eyebrow {
  margin: 0;
  color: var(--ion-color-primary);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.menu-config-master-switch {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.45rem;
  min-width: 17rem;
  padding: 0.6rem 0.75rem;
  border-radius: 0.75rem;
  background: var(--ion-color-step-100);
}
.menu-config-master-switch ion-toggle {
  flex: 1;
  font-weight: 600;
}
.menu-config-master-switch ion-icon {
  flex: 0 0 auto;
  color: var(--ion-color-medium);
  cursor: help;
  font-size: 1.25rem;
}

.menu-config-controls {
  display: grid;
  grid-template-columns: minmax(16rem, 0.8fr) minmax(22rem, 1.2fr);
  gap: 1rem;
  margin-top: 0.75rem;
  padding: 0.9rem 1rem;
  border-radius: 1rem;
}

.menu-config-context > label {
  display: block;
  margin-bottom: 0.35rem;
  color: var(--ion-color-medium);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.menu-config-context-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.menu-config-context-row ion-select {
  flex: 1;
  min-height: 2.75rem;
}
.menu-config-context-row ion-icon {
  flex: 0 0 auto;
  color: var(--ion-color-medium);
  cursor: help;
  font-size: 1.25rem;
}

.menu-config-search-actions {
  display: flex;
  align-items: end;
  gap: 0.5rem;
}
.menu-config-search-actions ion-searchbar {
  flex: 1;
  min-width: 0;
  padding: 0;
}
.menu-config-search-actions ion-button {
  flex: 0 0 auto;
  margin-bottom: 0.25rem;
}

.menu-config-guidance {
  grid-column: 1/-1;
  color: var(--ion-text-color);
  font-size: 0.85rem;
  line-height: 1.5;
}
.menu-config-guidance p {
  margin: 0;
  max-width: 80ch;
}
.menu-config-guidance .menu-config-role-hint {
  margin-top: 0.75rem;
}

.menu-config-help {
  margin-top: 0.5rem;
}
.menu-config-help summary {
  width: fit-content;
  min-height: 2.75rem;
  padding: 0.65rem 0.25rem;
  color: var(--ion-color-primary);
  font-weight: 600;
  cursor: pointer;
}
.menu-config-help summary:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  border-radius: 0.25rem;
}
.menu-config-help summary ion-icon {
  margin: 0 0.25rem;
  font-size: 1.15rem;
  vertical-align: middle;
}
.menu-config-help ul {
  max-width: 80ch;
  margin: 0.25rem 0 0.75rem;
  padding-left: 1.5rem;
  list-style: disc;
}
.menu-config-help li + li {
  margin-top: 0.5rem;
}

.menu-config-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 0.75rem;
  overflow: hidden;
  border-radius: 1rem;
}
.menu-config-stats > div {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.7rem 1rem;
  text-align: center;
}
.menu-config-stats > div + div {
  border-left: 1px solid var(--ion-color-step-150);
}
.menu-config-stats strong {
  font-size: 1.25rem;
}
.menu-config-stats span {
  color: var(--ion-color-medium);
  font-size: 0.8rem;
}
.menu-config-stats .menu-config-stat-alert strong {
  color: var(--ion-color-warning-shade);
}

.menu-config-notice {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-top: 0.75rem;
  padding: 0.7rem 0.9rem;
  border-color: var(--ion-color-warning);
  border-radius: 0.75rem;
  background: rgba(var(--ion-color-warning-rgb), 0.09);
}
.menu-config-notice > ion-icon {
  flex: 0 0 auto;
  color: var(--ion-color-warning-shade);
  font-size: 1.4rem;
}
.menu-config-notice > div {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 0.45rem;
  font-size: 0.85rem;
}
.menu-config-notice span {
  color: var(--ion-color-medium);
}

.menu-config-empty {
  display: grid;
  justify-items: center;
  gap: 0.5rem;
  padding: 2.5rem 1rem;
  color: var(--ion-color-medium);
  text-align: center;
}
.menu-config-empty ion-icon {
  font-size: 2rem;
}
.menu-config-empty p {
  margin: 0;
}

.menu-config-groups {
  display: block;
  margin-top: 0.75rem;
  overflow: hidden;
  border-radius: 1rem;
}

.menu-config-section-header ion-label {
  font-size: 1rem;
  font-weight: 700;
}

.menu-config-section-counts {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  color: var(--ion-color-medium);
  font-size: 0.72rem;
  white-space: nowrap;
}

.menu-config-section-content {
  padding: 0.25rem 0.5rem 0.55rem;
  background: var(--ion-color-step-50);
}

.menu-config-row {
  --padding-start: 0.65rem;
  --inner-padding-end: 0.65rem;
  margin: 0.2rem 0;
}
.menu-config-row ion-checkbox {
  flex: 1;
  min-width: 0;
}
.menu-config-row ion-checkbox::part(label) {
  white-space: normal;
}

.menu-config-inherited-note {
  display: block;
  margin-top: 0.2rem;
  color: var(--ion-text-color);
  font-size: 0.75rem;
  line-height: 1.4;
}

.menu-config-row-inherited {
  --background: rgba(var(--ion-color-warning-rgb), 0.09);
}

.menu-config-row-unavailable {
  opacity: 0.58;
}

.menu-config-row-excluded ion-checkbox span {
  color: var(--ion-color-medium);
  text-decoration: line-through;
}

.menu-config-row-status {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-left: 0.5rem;
}
.menu-config-row-status ion-icon {
  font-size: 1.15rem;
}
.menu-config-row-status ion-icon:first-child {
  color: var(--ion-color-medium);
  cursor: help;
}

.menu-config-actions {
  position: sticky;
  bottom: 0;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 0.75rem;
  padding: 0.55rem 0.75rem;
  border-radius: 0.9rem;
  box-shadow: 0 -0.25rem 0.8rem rgba(15, 23, 42, 0.08);
}
.menu-config-actions > span {
  color: var(--ion-color-medium);
  font-size: 0.8rem;
}

@media (max-width: 767px) {
  .menu-config-shell {
    padding: 0.5rem;
  }
  .menu-config-hero {
    align-items: stretch;
    flex-direction: column;
    gap: 0.9rem;
  }
  .menu-config-master-switch {
    min-width: 0;
  }
  .menu-config-controls {
    grid-template-columns: 1fr;
  }
  .menu-config-search-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .menu-config-search-actions ion-button {
    align-self: flex-end;
    margin-bottom: 0;
  }
  .menu-config-stats > div {
    align-items: center;
    flex-direction: column;
    gap: 0.05rem;
    padding: 0.55rem 0.3rem;
  }
  .menu-config-stats strong {
    font-size: 1.05rem;
  }
  .menu-config-stats span {
    font-size: 0.68rem;
  }
  .menu-config-section-counts > span {
    display: none;
  }
  .menu-config-actions > span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/licenze/licenze-menu-config/licenze-menu-config.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;;;;;;EAME,2CAAA;EACA,mEAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;AACF;;AAGE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,SAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;AADJ;;AAKA;EACE,SAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qCAAA;AAFF;AAIE;EACE,OAAA;EACA,gBAAA;AAFJ;AAKE;EACE,cAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,gEAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAJF;;AAQE;EACE,cAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AANF;AAQE;EACE,OAAA;EACA,mBAAA;AANJ;AASE;EACE,cAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,gBAAA;EACA,WAAA;AARF;AAUE;EACE,OAAA;EACA,YAAA;EACA,UAAA;AARJ;AAWE;EACE,cAAA;EACA,sBAAA;AATJ;;AAaA;EACE,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAVF;AAYE;EACE,SAAA;EACA,eAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;;AAeA;EACE,kBAAA;AAZF;AAcE;EACE,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AAZJ;AAcI;EACE,2CAAA;EACA,mBAAA;EACA,sBAAA;AAZN;AAeI;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;AAbN;AAiBE;EACE,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,kBAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;AAjBJ;AAmBI;EACE,gDAAA;AAjBN;AAqBE;EACE,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,iBAAA;AApBJ;AAuBE;EACE,qCAAA;AArBJ;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,oDAAA;AAtBF;AAwBE;EACE,cAAA;EACA,qCAAA;EACA,iBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AAvBJ;AA0BE;EACE,8BAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,kBAAA;AAzBF;AA2BE;EACE,eAAA;AAzBJ;AA4BE;EACE,SAAA;AA1BJ;;AA8BA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA3BF;;AA+BE;EACE,eAAA;EACA,gBAAA;AA5BJ;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,+BAAA;EACA,oCAAA;AA7BF;;AAgCA;EACE,wBAAA;EACA,4BAAA;EACA,gBAAA;AA7BF;AA+BE;EACE,OAAA;EACA,YAAA;AA7BJ;AA+BI;EACE,mBAAA;AA7BN;;AAkCA;EACE,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AA/BF;;AAkCA;EACE,sDAAA;AA/BF;;AAkCA;EACE,aAAA;AA/BF;;AAkCA;EACE,8BAAA;EACA,6BAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AA/BF;AAiCE;EACE,kBAAA;AA/BJ;AAkCE;EACE,8BAAA;EACA,YAAA;AAhCJ;;AAoCA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,oDAAA;AAjCF;AAmCE;EACE,8BAAA;EACA,iBAAA;AAjCJ;;AAqCA;EACE;IACE,eAAA;EAlCF;EAqCA;IACE,oBAAA;IACA,sBAAA;IACA,WAAA;EAnCF;EAsCA;IACE,YAAA;EApCF;EAuCA;IACE,0BAAA;EArCF;EAwCA;IACE,oBAAA;IACA,sBAAA;EAtCF;EAwCE;IACE,oBAAA;IACA,gBAAA;EAtCJ;EA2CE;IACE,mBAAA;IACA,sBAAA;IACA,YAAA;IACA,uBAAA;EAzCJ;EA4CE;IACE,kBAAA;EA1CJ;EA6CE;IACE,kBAAA;EA3CJ;EA+CA;IACE,aAAA;EA7CF;EAiDE;IACE,aAAA;EA/CJ;AACF","sourcesContent":[".menu-config-shell {\n  width: min(100%, 72rem);\n  margin: 0 auto;\n  padding: 0.75rem;\n}\n\n.menu-config-hero,\n.menu-config-controls,\n.menu-config-stats,\n.menu-config-notice,\n.menu-config-groups,\n.menu-config-actions {\n  border: 1px solid var(--ion-color-step-150);\n  background: var(--ion-card-background, var(--ion-background-color));\n}\n\n.menu-config-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 1.1rem 1.25rem;\n  border-radius: 1rem;\n  box-shadow: 0 0.35rem 1rem rgba(15, 23, 42, 0.08);\n}\n\n.menu-config-intro {\n  h2 {\n    margin: 0.15rem 0 0.35rem;\n    font-size: 1.35rem;\n    font-weight: 700;\n    line-height: 1.7rem;\n  }\n\n  > p:last-child {\n    max-width: 46rem;\n    margin: 0;\n    color: var(--ion-color-medium);\n    font-size: 0.9rem;\n    line-height: 1.35rem;\n  }\n}\n\n.menu-config-eyebrow {\n  margin: 0;\n  color: var(--ion-color-primary);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.menu-config-master-switch {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 17rem;\n  padding: 0.6rem 0.75rem;\n  border-radius: 0.75rem;\n  background: var(--ion-color-step-100);\n\n  ion-toggle {\n    flex: 1;\n    font-weight: 600;\n  }\n\n  ion-icon {\n    flex: 0 0 auto;\n    color: var(--ion-color-medium);\n    cursor: help;\n    font-size: 1.25rem;\n  }\n}\n\n.menu-config-controls {\n  display: grid;\n  grid-template-columns: minmax(16rem, 0.8fr) minmax(22rem, 1.2fr);\n  gap: 1rem;\n  margin-top: 0.75rem;\n  padding: 0.9rem 1rem;\n  border-radius: 1rem;\n}\n\n.menu-config-context {\n  > label {\n    display: block;\n    margin-bottom: 0.35rem;\n    color: var(--ion-color-medium);\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n  }\n}\n\n.menu-config-context-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n\n  ion-select {\n    flex: 1;\n    min-height: 2.75rem;\n  }\n\n  ion-icon {\n    flex: 0 0 auto;\n    color: var(--ion-color-medium);\n    cursor: help;\n    font-size: 1.25rem;\n  }\n}\n\n.menu-config-search-actions {\n  display: flex;\n  align-items: end;\n  gap: 0.5rem;\n\n  ion-searchbar {\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n  }\n\n  ion-button {\n    flex: 0 0 auto;\n    margin-bottom: 0.25rem;\n  }\n}\n\n.menu-config-guidance {\n  grid-column: 1 / -1;\n  color: var(--ion-text-color);\n  font-size: 0.85rem;\n  line-height: 1.5;\n\n  p {\n    margin: 0;\n    max-width: 80ch;\n  }\n\n  .menu-config-role-hint {\n    margin-top: 0.75rem;\n  }\n}\n\n.menu-config-help {\n  margin-top: 0.5rem;\n\n  summary {\n    width: fit-content;\n    min-height: 2.75rem;\n    padding: 0.65rem 0.25rem;\n    color: var(--ion-color-primary);\n    font-weight: 600;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n      border-radius: 0.25rem;\n    }\n\n    ion-icon {\n      margin: 0 0.25rem;\n      font-size: 1.15rem;\n      vertical-align: middle;\n    }\n  }\n\n  ul {\n    max-width: 80ch;\n    margin: 0.25rem 0 0.75rem;\n    padding-left: 1.5rem;\n    list-style: disc;\n  }\n\n  li + li {\n    margin-top: 0.5rem;\n  }\n}\n\n.menu-config-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  margin-top: 0.75rem;\n  overflow: hidden;\n  border-radius: 1rem;\n\n  > div {\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    gap: 0.4rem;\n    padding: 0.7rem 1rem;\n    text-align: center;\n\n    + div {\n      border-left: 1px solid var(--ion-color-step-150);\n    }\n  }\n\n  strong {\n    font-size: 1.25rem;\n  }\n\n  span {\n    color: var(--ion-color-medium);\n    font-size: 0.8rem;\n  }\n\n  .menu-config-stat-alert strong {\n    color: var(--ion-color-warning-shade);\n  }\n}\n\n.menu-config-notice {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin-top: 0.75rem;\n  padding: 0.7rem 0.9rem;\n  border-color: var(--ion-color-warning);\n  border-radius: 0.75rem;\n  background: rgba(var(--ion-color-warning-rgb), 0.09);\n\n  > ion-icon {\n    flex: 0 0 auto;\n    color: var(--ion-color-warning-shade);\n    font-size: 1.4rem;\n  }\n\n  > div {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.25rem 0.45rem;\n    font-size: 0.85rem;\n  }\n\n  span {\n    color: var(--ion-color-medium);\n  }\n}\n\n.menu-config-empty {\n  display: grid;\n  justify-items: center;\n  gap: 0.5rem;\n  padding: 2.5rem 1rem;\n  color: var(--ion-color-medium);\n  text-align: center;\n\n  ion-icon {\n    font-size: 2rem;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n.menu-config-groups {\n  display: block;\n  margin-top: 0.75rem;\n  overflow: hidden;\n  border-radius: 1rem;\n}\n\n.menu-config-section-header {\n  ion-label {\n    font-size: 1rem;\n    font-weight: 700;\n  }\n}\n\n.menu-config-section-counts {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: var(--ion-color-medium);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.menu-config-section-content {\n  padding: 0.25rem 0.5rem 0.55rem;\n  background: var(--ion-color-step-50);\n}\n\n.menu-config-row {\n  --padding-start: 0.65rem;\n  --inner-padding-end: 0.65rem;\n  margin: 0.2rem 0;\n\n  ion-checkbox {\n    flex: 1;\n    min-width: 0;\n\n    &::part(label) {\n      white-space: normal;\n    }\n  }\n}\n\n.menu-config-inherited-note {\n  display: block;\n  margin-top: 0.2rem;\n  color: var(--ion-text-color);\n  font-size: 0.75rem;\n  line-height: 1.4;\n}\n\n.menu-config-row-inherited {\n  --background: rgba(var(--ion-color-warning-rgb), 0.09);\n}\n\n.menu-config-row-unavailable {\n  opacity: 0.58;\n}\n\n.menu-config-row-excluded ion-checkbox span {\n  color: var(--ion-color-medium);\n  text-decoration: line-through;\n}\n\n.menu-config-row-status {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-left: 0.5rem;\n\n  ion-icon {\n    font-size: 1.15rem;\n  }\n\n  ion-icon:first-child {\n    color: var(--ion-color-medium);\n    cursor: help;\n  }\n}\n\n.menu-config-actions {\n  position: sticky;\n  bottom: 0;\n  z-index: 8;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 0.75rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 0.9rem;\n  box-shadow: 0 -0.25rem 0.8rem rgba(15, 23, 42, 0.08);\n\n  > span {\n    color: var(--ion-color-medium);\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .menu-config-shell {\n    padding: 0.5rem;\n  }\n\n  .menu-config-hero {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 0.9rem;\n  }\n\n  .menu-config-master-switch {\n    min-width: 0;\n  }\n\n  .menu-config-controls {\n    grid-template-columns: 1fr;\n  }\n\n  .menu-config-search-actions {\n    align-items: stretch;\n    flex-direction: column;\n\n    ion-button {\n      align-self: flex-end;\n      margin-bottom: 0;\n    }\n  }\n\n  .menu-config-stats {\n    > div {\n      align-items: center;\n      flex-direction: column;\n      gap: 0.05rem;\n      padding: 0.55rem 0.3rem;\n    }\n\n    strong {\n      font-size: 1.05rem;\n    }\n\n    span {\n      font-size: 0.68rem;\n    }\n  }\n\n  .menu-config-section-counts > span {\n    display: none;\n  }\n\n  .menu-config-actions {\n    > span {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
